module.exports = __webpack_public_path__ + "img/MemeETC (5).5c61fe7c.jpeg";